var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoviesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 19.5H26C18.8305 19.5 13 25.3305 13 32.5V123.5C13 130.67 18.8305 136.5 26 136.5H130C137.17 136.5 143 130.67 143 123.5V32.5C143 25.3305 137.17 19.5 130 19.5ZM130.007 58.5C130 58.5 130 58.5 130.007 58.5H126.984L109.648 32.5H130L130.007 58.5ZM61.984 58.5L44.6485 32.5H61.5225L78.858 58.5H61.984ZM94.484 58.5L77.1485 32.5H94.0225L111.358 58.5H94.484ZM26 32.5H29.0225L46.358 58.5H26V32.5ZM26 123.5V71.5H130L130.013 123.5H26Z",
    fill: "#0066FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 117L100.75 97.5L65 78V117Z",
    fill: "#0066FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoviesIcon);
export default __webpack_public_path__ + "static/media/movies_icon.09980b0f.svg";
export { ForwardRef as ReactComponent };